module.exports = __webpack_public_path__ + "static/img/lotte.09755f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte.jpg
// module id = c6Co
// module chunks = 0